class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.searchTriggerElement = document.querySelector('#main-search-trigger svg');
    this._isOpen = false;
    this.gtmDebounceTimeOut = null;

    this.bannedWords = [
      { word: 'hidden', startAt: 3 },
      { word: 'promo', startAt: 4 },
      { word: 'recharge', startAt: 3 },
      { word: 'rebuy', startAt: 3 },
      { word: 'fomo', startAt: 3 },
      { word: 'filtering', startAt: 5 },
    ];

    this.setupEventListeners();
  }

  get isOpen() {
    return this._isOpen;
  }

  set isOpen(value) {
    this._isOpen = value;
    this.onIsOpenChange(value);
  }

  onIsOpenChange(value) {
    console.log('VAAAAALUE', value)
    // document.body.style.overflow = value ? 'hidden' : 'auto';
  }

  setupEventListeners() {
    const form = this.querySelector('form.search');
    form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener(
      'input',
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
    this.searchTriggerElement?.addEventListener('click', this.inputFocusHandler.bind(this));
  }

  inputFocusHandler() {
    setTimeout(() => this.input.focus(), 100);

    dataLayerPromise({
      event: 'navigation_interaction',
      section: 'top_bar',
      element: 'icon_button',
      element_value: 'search_icon',
      interaction_type: 'click',
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  getPrefixes({ word, startAt = 3 }) {
    const result = [];
    for (let len = startAt; len <= word.length; len++) {
      result.push(word.substring(0, len));
    }
    return result;
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.close(true);
      return;
    }

    const extendedBannedArray = this.bannedWords.flatMap(this.getPrefixes);
    const isSearchTermBanned = extendedBannedArray.includes(searchTerm);

    this.getSearchResults(isSearchTermBanned ? 'ykykykyk' : searchTerm, searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) return;

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  onFocusOut() {
    const searchTerm = this.getQuery();
    dataLayer.push({
      event: 'custom_search',
      search_term: searchTerm,
    });

    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll('li');
    let activeElement = this.querySelector('li');

    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

    const searchTerm = this.getQuery();

    dataLayer.push({
      event: 'custom_search',
      search_term: searchTerm,
    });

    dataLayerPromise({
      event: 'search_enter',
      search_term: searchTerm,
    });

    if (selectedProduct) selectedProduct.click();
  }

  getSearchResults(searchTerm, realSearchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey], searchTerm, realSearchTerm);
      return;
    }

    const params = {
      q: searchTerm,
      section_id: 'predictive-search',
      'resources[type]': 'product',
      'resources[limit]': 10,
      'resources[options][fields]': ['title', 'product_type', 'variants.title', 'vendor', 'tag', 'body'],
    };

    const queryString = new URLSearchParams(params).toString();
    const url = `${routes.predictive_search_url}?${queryString}`;

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup, searchTerm);
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  trackEventsAfterLinkClick(searchTerm) {
    const links = this.predictiveSearchResults.querySelectorAll(
      '.predictive-search__item.predictive-search__item--link'
    );

    if (this.gtmDebounceTimeOut) {
      clearTimeout(this.gtmDebounceTimeOut);
    }

    this.gtmDebounceTimeOut = setTimeout(() => {
      dataLayerPromise({
        event: 'search_interaction',
        section: 'search_modal',
        element: `listing_${links.length}`,
        element_value: searchTerm,
        interaction_type: 'visible',
      });
    }, 1000);

    links.forEach((link) => {
      link.onclick = (e) => {
        e.preventDefault();
        dataLayerPromise({
          event: 'search_interaction',
          section: 'search_modal',
          element: link.getAttribute('data-product') ?? '',
          element_value: searchTerm,
          interaction_type: 'click',
        }).then(() => {
          window.location = link.href;
        });
      };
    });
  }

  trackNoResultsEvent(searchTerm, realSearchTerm) {
    dataLayerPromise({
      event: 'search_interaction',
      section: 'search_modal',
      element: 'no_results',
      element_value: searchTerm === 'ykykykyk' ? `$ban: ${realSearchTerm}` : searchTerm,
      interaction_type: 'click',
    });
  }

  renderSearchResults(resultsMarkup, querySearchTerm, realSearchTerm) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(resultsMarkup, 'text/html');
    const items = doc.querySelectorAll('li');
    const itemsArray = Array.from(items);
    const searchTerm = this.getQuery().toLowerCase();

    itemsArray.sort((a, b) => {
      const titleA = a.querySelector('a, button').textContent.trim().toLowerCase();
      const titleB = b.querySelector('a, button').textContent.trim().toLowerCase();

      const wordsA = titleA.split(' ');
      const wordsB = titleB.split(' ');

      const startsWithA = titleA.startsWith(searchTerm);
      const startsWithB = titleB.startsWith(searchTerm);

      if (startsWithA && !startsWithB) return -1;
      if (!startsWithA && startsWithB) return 1;

      const secondWordIsTermA = wordsA[1] && wordsA[1] === searchTerm;
      const secondWordIsTermB = wordsB[1] && wordsB[1] === searchTerm;

      if (secondWordIsTermA && !secondWordIsTermB) return -1;
      if (!secondWordIsTermA && secondWordIsTermB) return 1;

      if (secondWordIsTermA && secondWordIsTermB) {
        const firstWordA = wordsA[0];
        const firstWordB = wordsB[0];
        return firstWordA.localeCompare(firstWordB);
      }

      return 0;
    });

    let sortedResultsMarkup =
      '<ul id="predictive-search-results-list" class="predictive-search__results-list list-unstyled" role="listbox" aria-labelledby="predictive-search-products">';

    itemsArray.forEach((item, index) => {
      item.style.setProperty('--delay', `${index++ * 50}ms`);
      sortedResultsMarkup += item.outerHTML;
    });

    sortedResultsMarkup += '</ul>';

    const keySearchElement = doc.getElementById('predictive-search-option-search-keywords');

    if (keySearchElement) {
      keySearchElement.remove();
    }

    const container = doc.querySelector('#predictive-search-results');
    container.querySelector('#predictive-search-results-list').outerHTML = sortedResultsMarkup;

    const scrollWrapper = document.querySelector('.predictive-search.predictive-search--header');
    if (scrollWrapper) scrollWrapper.scrollTop = 0;

    const regex = new RegExp(/Brak wyników/);
    container.innerHTML += `<span class="predictive-search__no-results" data-predictive-search-live-region-count-value="">${regex.test(resultsMarkup) || itemsArray.length === 1 ? `<span class="predictive-search-empty-state">Brak wyników</span>` : ''}</span>`;

    this.predictiveSearchResults.innerHTML = container.innerHTML;
    this.setAttribute('results', true);
    this.setLiveRegionResults();
    this.open();

    if (regex.test(resultsMarkup) || itemsArray.length === 1) {
      this.trackNoResultsEvent(querySearchTerm, realSearchTerm);
    } else {
      this.trackEventsAfterLinkClick(querySearchTerm);
    }
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.getElementById('shopify-section-header').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }

    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');

    this.isOpen = false;
  }
}

const closeButton = document.querySelector('.modal__close-button');
const details = document.querySelector('details');

closeButton.addEventListener('click', function () {
  details.removeAttribute('open');
});

const overlay = document.querySelector('.search-modal .modal-overlay');
overlay.addEventListener('click', () => details.removeAttribute('open'));

customElements.define('predictive-search', PredictiveSearch);
